import gql from 'graphql-tag';

import type { BlogPostBuilderBrief, KeywordData } from 'src/data/blog';
import type { Language } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type { BackendMutationUpdateBlogPostBuilderSettingsArgs } from 'src/types/backend';

import { FRAGMENT_BLOG_POST_BUILDER_BRIEF } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderSettings(
    $id: ID!
    $keywords: [String!]
    $targetKeywords: [String!]
    $supportingKeywords: JSON
    $customerPersonaId: ID
    $tovInput: TovInput
    $language: String
    $generationCustomModelId: ID
  ) {
    updateBlogPostBuilderSettings(
      id: $id
      keywords: $keywords
      targetKeywords: $targetKeywords
      supportingKeywords: $supportingKeywords
      customerPersonaId: $customerPersonaId
      tovInput: $tovInput
      language: $language
      generationCustomModelId: $generationCustomModelId
    ) {
      ...BlogPostBuilderBrief
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_BRIEF}
`;

type Variables = Override<
  BackendMutationUpdateBlogPostBuilderSettingsArgs,
  {
    supportingKeywords?: KeywordData[];
    language?: Language;
  }
>;

export const updateBlogPostBuilderSettings = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BlogPostBuilderBrief>(result.data);
};
